import * as request from '../api-request'

export const getCurrentVersion = (data) => {
  return request.toJSON('GET', 'check_version', data)
}
